module.exports = __webpack_public_path__ + "media/images/icons/filled/file-pdf-8eda9a616615cafc84b49633e22e2964.svg";